import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CommissionTable} from '../../../../shared/interface/commission-table';
import {CommissionTableService} from '../../../../shared/services/commission-table.service';

@Component({
  selector: 'app-commission-table-details',
  templateUrl: './commission-table-details.component.html',
  styleUrls: ['./commission-table-details.component.scss']
})
export class CommissionTableDetailsComponent
  implements OnInit, OnDestroy {

  commissionTableId: string;

  commissionTableObject?: CommissionTable;

  commissionTable: ReplaySubject<CommissionTable>
    = new ReplaySubject<CommissionTable>(1);

  modify = false;

  private destroyed$: ReplaySubject<boolean>
    = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private commissionTableService: CommissionTableService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        this.commissionTableId = params.id;

        this.loadCommissionTable();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadCommissionTable(): void {
    this.commissionTableService
      .get(this.commissionTableId)
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(
        (commissionTable: CommissionTable) => {
          this.commissionTableObject = commissionTable;
          this.commissionTable.next(commissionTable);
        },
        (error: HttpErrorResponse) => {
          this.snack.open(
            'Nie udało się pobrać tabeli prowizyjnej',
            error.status.toString(),
            {
              duration: 2000
            }
          );
        }
      );
  }

  modificationClosed(): void {
    this.modify = false;
    this.loadCommissionTable();
  }
}
